'use client';

import { useState, type FC, type PropsWithChildren } from 'react';

import { TabContext, TabList } from '@mui/lab';
import Box from '@mui/material/Box';

interface TabContainerProps extends PropsWithChildren {
    tabPanels: React.ReactNode;
    defaultTab: string;
}

const TabContainer: FC<TabContainerProps> = ({
    children,
    defaultTab,
    tabPanels,
}) => {
    const [value, setValue] = useState(defaultTab);

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return (
        <Box
            sx={{
                borderTop: 1,
                borderBottom: 1,
                borderColor: 'divider',
                mt: 5,
                ml: '-20px',
                mr: '-20px',
            }}
        >
            <TabContext value={value}>
                <TabList
                    onChange={handleChange}
                    aria-label='tabs'
                    sx={{
                        bgcolor: '#f0f2f4',
                    }}
                >
                    {children}
                </TabList>
                <div className='p-5'>{tabPanels}</div>
            </TabContext>
        </Box>
    );
};

export default TabContainer;
